import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import { usePartialState } from '@tencent/dz-models';
import { usePageModel } from '../context';
export var Footer = function (props) {
    var View = useComponents().View;
    var model = usePageModel();
    var _a = usePartialState(function () { return model.getMessageModel(); }), msgModel = _a[1];
    return (React.createElement(View, { style: {
            order: msgModel.messageQueue.length + 1,
            zIndex: 999,
        }, className: "footer" }, props.children));
};
